import { useState, useEffect } from "react";

import API from "utils/api";

export default function useMigrationReference(type, id) {
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);

  useEffect(() => {
    async function fetchMigrationReference() {
      setLoading(true);
      const { response, data } = await API.fetchMigrationReference(type, id);

      if (response.ok) {
        setResult(data);
      } else {
        setResult(null);
      }

      setLoading(false);
    }

    fetchMigrationReference();
  }, [type, id]);

  return { loading, url: result?.url ?? null };
}
